import {Image} from '@shopify/hydrogen';
import {useEffect, useState} from 'react';
import sortImage from '../../../assets/image/sort.svg';
import filterImage from '../../../assets/image/filter.svg';
import { useAppDispatch } from '../../../lib/hooks';
import { defineOrder, executeSearch } from '../../../store/slices/search';
import AZ from '../../../assets/image/search-icons/a-z.svg';
import ZA from '../../../assets/image/search-icons/z-a.svg';
import arrowDown from '../../../assets/image/search-icons/arrow-down.svg';
import arrowUp from '../../../assets/image/search-icons/arrow-up.svg';
import hurt from '../../../assets/image/search-icons/hurt.svg';
import start from '../../../assets/image/search-icons/start.svg';
import AZW from '../../../assets/image/search-icons/white/a-z.svg';
import ZAW from '../../../assets/image/search-icons/white/z-a.svg';
import arrowDownW from '../../../assets/image/search-icons/white/arrow-down.svg';
import arrowUpW from '../../../assets/image/search-icons/white/arrow-up.svg';
import hurtW from '../../../assets/image/search-icons/white/hurt.svg';
import startW from '../../../assets/image/search-icons/white/start.svg';
import { sendEvent } from '../../../lib/analitycs';
import { hasUrlSection } from '../../../lib/Utils';

export default function Sort({toogleFilters}) {
  const defaultLabel = hasUrlSection('/search') ? 'Orden: Relevancia' : 'Orden: Más recientes';
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [label, setLabel] = useState(defaultLabel);
  const [iconLabel, setIconLabel] = useState(hurtW);
  const [isTagOrCategory, setIsTagOrCategory] = useState(false);
  
  const toggleOpen = ()=>{
    setIsOpen(!isOpen);
  }

  const toggleOpenFilters = ()=>{
    toogleFilters();
  }

  const chooseOption = (order)=>{
    trackEvent(order);
    dispatch(defineOrder(order));
    dispatch(executeSearch());
    setIsOpen(false);

    if(order === 'o_relevance=desc'){
      setLabel('Orden: Relevancia');
      setIconLabel(hurtW);
    }else if(order === 'o_date=desc'){
      setLabel('Orden: Más recientes');
      setIconLabel(startW);
    }else if(order === 'o_price=asc'){
      setLabel('Orden: Precio');
      setIconLabel(arrowUpW);
    }else if(order === 'o_price=desc'){
      setLabel('Orden: Precio');
      setIconLabel(arrowDownW);
    }else if(order === 'o_title=asc'){
      setLabel('Orden: Alfabético');
      setIconLabel(AZW);
    }else if(order === 'o_title=desc'){
      setLabel('Orden: Alfabético');
      setIconLabel(ZAW);
    }
  }

  const trackEvent = (order)=>{
    sendEvent('list_order',{
      list_option: order
    });
  }

  const closemenu = ()=>{
    setIsOpen(false);
  }

  useEffect(()=>{
    if(hasUrlSection('/search')){
      setIsTagOrCategory(true);
    }
  },[])

  return (
    <>
      <div id='order-buttons-options'>
        <div className='flex gap-2 xs:flex-row xs:w-full xs:flex xs:justify-between xs:items-center xs:pt-2'>
          <button
            className="xs:visible md:hidden btn-main btn-wicon btn-icon-left bg-purple-120 text-white font-bold px-5 py-4 rounded-full w-52 xs:p-3 xs:w-6/12 xs:text-sm "
            onClick={toggleOpenFilters}
          >
            <Image
              src={hurt}
              width={19}
              height={19}
              alt="Filter"
              className="inline mr-2 btn-icon"
            />
            <span className="inline leading-none"> Filtrar resultados </span>
          </button>
          <button
            className="btn-main btn-wicon btn-icon-right bg-purple-120 text-white rounded-full button-order"
            onClick={toggleOpen}
          >
            <span className="inline mr-2 leading-none">{label}</span>
            <Image
              src={iconLabel}
              width={15}
              height={15}
              className="inline btn-icon"
              alt="Sort"
            />
          </button>
        </div>
        <div className={`
              flex flex-col items-start absolute z-20 bg-white  text-left shadow-sm rounded-md panel-buttons
              ${!isOpen ? 'hidden' : ''}
        `} onMouseLeave={closemenu}>

          {isTagOrCategory && (
              <button
                className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
                onClick={()=>{chooseOption('o_relevance=desc');}}
              >
                <span>
                  Relevancia
                </span>
                <Image
                    src={hurt}
                    height={25}
                    width={25}
                    className="inline iconorder"
                />
              </button>
          )}

          <button
            className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
            onClick={()=>{chooseOption('o_date=desc');}}
          >
            <span>
              Más recientes
            </span>
            <Image
                src={start}
                height={25}
                width={25}
                className="inline iconorder"
            />
          </button>
          <button
            className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
            onClick={()=>{chooseOption('o_price=asc');}}
          >
            <span>
              Precio
            </span>
            <Image
                src={arrowUp}
                height={25}
                width={25}
                className="inline iconorder"
            />
          </button>
          <button
            className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
            onClick={()=>{chooseOption('o_price=desc');}}
          >
            <span>
              Precio
            </span>
            <Image
                src={arrowDown}
                height={25}
                width={25}
                className="inline iconorder"
            />
          </button>
          <button
            className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
            onClick={()=>{chooseOption('o_title=asc');}}
          >
            <span>
              Alfabético
            </span>
            <Image
                src={AZ}
                height={20}
                width={26}
                className="inline iconorder"
            />
          </button>
          <button
            className="text-left mt-2 hover:text-light-purple hover:bg-purple-40 hover:text-white px-5 w-full"
            onClick={()=>{chooseOption('o_title=desc');}}
          >
            <span>
              Alfabético
            </span>
            <Image
                src={ZA}
                height={20}
                width={26}
                className="inline iconorder"
            />
          </button>
        </div>
      </div>
    </>
  );
}
